import { CANCEL_EDIT_NOTE } from 'constants/action_types'

export default function doCancelEditNote() {
  return {
    type: CANCEL_EDIT_NOTE,
  }
}
